import { render, staticRenderFns } from "./ServicePlaceInformationList.vue?vue&type=template&id=b31bfe52&scoped=true"
import script from "./ServicePlaceInformationList.vue?vue&type=script&lang=js"
export * from "./ServicePlaceInformationList.vue?vue&type=script&lang=js"
import style0 from "./ServicePlaceInformationList.vue?vue&type=style&index=0&id=b31bfe52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31bfe52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31bfe52')) {
      api.createRecord('b31bfe52', component.options)
    } else {
      api.reload('b31bfe52', component.options)
    }
    module.hot.accept("./ServicePlaceInformationList.vue?vue&type=template&id=b31bfe52&scoped=true", function () {
      api.rerender('b31bfe52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/management/components/specialist-tab/components/ServicePlaceInformationList.vue"
export default component.exports